import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

export default function PayInvoiceSuccess() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    // Auto-close after 5 seconds
    if (countdown === 0) {
      window.close();
    }
  }, [countdown]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
            <CheckCircle className="h-8 w-8 text-gray-900" />
          </div>
          <h1 className="text-2xl font-semibold text-gray-900 mb-2">Payment Successful</h1>
          <p className="text-gray-600 mb-4 text-sm leading-relaxed">
            Your payment has been processed successfully. You should receive a confirmation email shortly.
          </p>
        </div>

        <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-6">
          <div className="flex items-start">
            <CheckCircle className="h-5 w-5 text-gray-900 mr-3 mt-0.5 flex-shrink-0" />
            <div className="text-left">
              <h3 className="font-medium text-gray-900 mb-1 text-sm">Payment Confirmed</h3>
              <p className="text-xs text-gray-600 leading-relaxed">
                Your invoice has been paid. A receipt has been sent to your email address.
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          {countdown > 0 && (
            <p className="text-xs text-gray-500 mb-2">
              This window will close automatically in {countdown} second{countdown !== 1 ? 's' : ''}
            </p>
          )}
          <button
            onClick={() => window.close()}
            className="w-full bg-[#007AFF] text-white py-3 px-4 rounded-lg font-medium hover:bg-[#0051D5] transition-colors duration-200"
          >
            Close Window
          </button>
        </div>
      </div>
    </div>
  );
}

